module.exports = __webpack_public_path__ + "h5/img/medal01.e166057f.png";